export default __webpack_public_path__ + "static/media/four.42944614.png";